import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=641e4878&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=641e4878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e4878",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('641e4878')) {
      api.createRecord('641e4878', component.options)
    } else {
      api.reload('641e4878', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=641e4878&scoped=true&", function () {
      api.rerender('641e4878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4txOZF42RsXAR/JS/comp/SearchFilterTokens.vue"
export default component.exports